import { UPDATE_BROADCAST_SETTINGS } from '../Types';

function setBroadcastSettings(settings) {
  return dispatch =>
    dispatch({ type: UPDATE_BROADCAST_SETTINGS, payload: settings });
}

export default setBroadcastSettings;
